import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref, computed } from "vue"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import PrinterConfigModule from "@/store/modules/printers-config"; // constants

import { getPrinters } from "@/api/group/printer";
import { TicketTypes } from "@/interfaces/receipts"; //helpers

import { getAvailablePrinters } from "@/utils/helpers/cross-platform"; // services

import storage, { LocalStorageKeys } from "@/services/storage.service";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "TicketsEmails",
  components: {},
  setup: function setup() {
    var printers = computed(function () {
      return PrinterConfigModule.printers;
    });
    var printerOption = ref(_objectSpread({}, PrinterConfigModule.printerOption));

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var availablePrinters = ref([]);
    var receiptPrinter = ref(getReceiptPrinter());
    var ticketPrinter = ref(PrinterConfigModule.ticketPrinter);
    var labelPrinter = ref(PrinterConfigModule.labelPrinter);
    var labelPrintingStatus = ref(PrinterConfigModule.isLabelPrintingEnabled);
    var showLocalPrinters = computed(function () {
      return POSConfigModule.isVHS;
    });
    getPrinters(POSConfigModule.groupId).then(function (printers) {
      PrinterConfigModule.setPrinters(printers);
    }).catch(function (error) {
      console.error(error);
    });

    function getReceiptPrinter() {
      var printer = storage.getLocalStorageItem(LocalStorageKeys.ReceiptPrinter);
      if (printer) return printer;
      return "";
    }

    var toggleStatus = function toggleStatus(status) {
      printerOption.value.auto = status;
    };

    var selectedTicketType = ref(PrinterConfigModule.ticketType || TicketTypes.Ticket);
    var ticketTypesArray = [{
      label: t("select.regular-ticket"),
      value: TicketTypes.Ticket
    }, {
      label: t("select.mini-ticket"),
      value: TicketTypes.MiniTicket
    }];
    var ticketPrintingStatus = ref(PrinterConfigModule.isTicketPrintingEnabled);

    function setTicketType(type) {
      PrinterConfigModule.setTicketType(type);
    }

    function setLabelPrintingStatus(status) {
      labelPrintingStatus.value = status;
    }

    function setTicketPrintingStatus(status) {
      ticketPrintingStatus.value = status;
    }

    return {
      printers: printers,
      printerOption: printerOption,
      toggleStatus: toggleStatus,
      availablePrinters: availablePrinters,
      receiptPrinter: receiptPrinter,
      ticketPrinter: ticketPrinter,
      ticketTypesArray: ticketTypesArray,
      selectedTicketType: selectedTicketType,
      setTicketType: setTicketType,
      TicketTypes: TicketTypes,
      t: t,
      labelPrinter: labelPrinter,
      labelPrintingStatus: labelPrintingStatus,
      setLabelPrintingStatus: setLabelPrintingStatus,
      ticketPrintingStatus: ticketPrintingStatus,
      setTicketPrintingStatus: setTicketPrintingStatus,
      showLocalPrinters: showLocalPrinters
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var availablePrinters;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAvailablePrinters();

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = [];

            case 5:
              availablePrinters = _context.t0;
              _this.availablePrinters = availablePrinters;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});